<template>
  <v-container class="cmp-catalog-projects-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedProjectDetails &&
                selectedProjectDetails.project &&
                selectedProjectDetails.project.project_name
            "
          >
            <span
              v-if="selectedProjectDetails && selectedProjectDetails.project"
              >{{
                selectedProjectDetails.project.project_name || $t('project_name')
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="selectedProjectDetails && selectedProjectDetails.project"
              >
                {{
                  selectedProjectDetails.project.project_name || $t('project_name')
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="projectSidewindowTabs"
        :loading="selectedProjectDetails && selectedProjectDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedProjectDetails &&
                      selectedProjectDetails.project_releases &&
                      selectedProjectDetails.project_releases.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('releases')"
              >
                <Releases
                  :selectedProjectDetails="selectedProjectDetails"
                  @add_click="onAddReleaseClick"
                />
              </gbox>
              <!-- :h="
                  boxHeight(
                    selectedProjectDetails &&
                      selectedProjectDetails.project_products &&
                      selectedProjectDetails.project_products.length,
                    NTOffsets.WithHeader
                  )
                " -->
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProjectDetails &&
                      selectedProjectDetails.project_products &&
                      selectedProjectDetails.project_products.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('related_products')"
              >
                <RelatedProducts
                  :selectedProjectDetails="selectedProjectDetails"
                  @selected="onSelectedProduct"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProjectDetails &&
                      selectedProjectDetails.project_tracks &&
                      selectedProjectDetails.project_tracks.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('related_tracks')"
              >
                <RelatedTracks
                  :selectedProjectDetails="selectedProjectDetails"
                  @selected="onSelectedTrack"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedProjectDetails.project.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedProjectDetails &&
                      selectedProjectDetails.contact_relations &&
                      selectedProjectDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  :contact_relations="selectedProjectDetails.contact_relations"
                  :external_id="`${selectedProjectDetails.project.project_id}`"
                  :external_table="'project'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProjectDetails &&
                      selectedProjectDetails.project_licences &&
                      selectedProjectDetails.project_licences.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('lincencing_string')"
              >
                <Lincencing
                  :selectedProjectDetails="selectedProjectDetails"
                  @selected="onSelectedLincencing"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="sales_planning_physical">
          <grow>
            <gcol>
              <gbox :title="$t('title')">
                <!-- sfj -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="sales_planning_digital">
          <grow>
            <gcol>
              <gbox :title="$t('title')">
                <!-- sfj -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="budget">
          <grow>
            <gcol>
              <gbox :title="$t('title')">
                <!-- sfj -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="costs">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedProjectDetails &&
                      selectedProjectDetails.costs &&
                      selectedProjectDetails.costs.length,
                    offset: NTOffsets.WithHeader,
                    min: 1
                  })
                "
                :title="$t('costgroups')"
              >
                <ProjectsCosts
                  :selectedProjectDetails="selectedProjectDetails"
                  @changed="onUpdateProjectsCosts"
                  @uploaded="onUploadFileClick"
                />
                <!-- <DboxCosts
                  :items="selectedProjectDetails.costs || []"
                  :cost_groups="
                    (selectedProjectDetails &&
                      selectedProjectDetails.costgroups) ||
                      []
                  "
                  :storeConfig="dboxCostConfig"
                  @updated="onProjectCostUpdated"
                /> -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="project_calculation">
          <grow>
            <gcol>
              <gbox :title="$t('title')">
                <!-- sfj -->
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addRelease'" :width="'small'">
      <AddRelease @cancelled="onDialogCancelled" @added="onReleaseAdded" />
      <!-- @set_main_product="onSetMainProduct" -->
    </ModalContainer>

    <ModalContainer :modalKey="'dfileUploader'" :width="'medium'">
      <DFileUploader
        @upLoad="onUploadFile"
        :allowedType="['xls', 'xlsx']"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { CatalogStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";

import { projectsCatalogGetters } from "../../store/projects/getters";
import { projectsCatalogActions } from "../../store/projects/actions";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import {
  licensingListLDTRoutes,
  productsListLDTRoutes,
  projectsListLDTRoutes,
  tracksListLDTRoutes
} from "../../router/routes";
import { checkTabListPermission } from "../../../../router/guard";
import {
  createModalMixin,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import { createTV } from "../../../../models/text-value.model";
import { MHTTPCL } from "../../../../services/http/http-client";

import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "@dtplugins/dbox-textarea/dbox-textarea";
import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import ModalContainer from "@dtplugins/modal/modal-container";
import DFileUploader from "@dtplugins/dfile-uploader/file-uploader";

import Releases from "./releases";
import AddRelease from "./add-release";
import RelatedProducts from "./related-products";
import RelatedTracks from "./related-tracks";
import Lincencing from "./lincencing";
import ProjectsCosts from "./projects-costs";

export const moduleRoute = "catalog";
export const submenuRoute = "projects";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    RealtedContacts,
    ModalContainer,
    DFileUploader,
    Releases,
    AddRelease,
    RelatedProducts,
    RelatedTracks,
    Lincencing,
    ProjectsCosts
  },
  data() {
    return {
      //
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addRelease"),
    createModalMixin("dfileUploader")
  ],
  computed: {
    ...mapGetterObject(storeNS, projectsCatalogGetters),

    projectSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview")
        },
        {
          route: "sales_planning_physical",
          value: this.$t("tab_title_label_project_sales_planning_phy")
        },
        {
          route: "sales_planning_digital",
          value: this.$t("tab_title_label_project_sales_planning_digi")
        },
        {
          route: "budget",
          value: this.$t("budget")
        },
        {
          route: "costs",
          value: this.$t("costs")
        },
        {
          route: "project_calculation",
          value: this.$t("tab_title_label_project_calculation")
        }
      ]);
    },

    // TABULATION REFACTORING

    project_id: function() {
      return this.$route.params.project_id;
    },

    selectedProjectDetails: function() {
      const projectDetails = this.projectDetails?.[this.project_id] || {};
      // this.projectDetails && this.projectDetails[this.project_id] || {};

      const project = projectDetails.project || {};
      console.log("selected Project", projectDetails);
      console.log("Project Details Overview", project);

      const project_details = projectDetails.project_details || {};
      const project_releases = projectDetails?.project_releases || [];
      const project_products = projectDetails?.project_products || [];
      const project_tracks = projectDetails?.project_tracks || [];
      const project_licences = projectDetails?.project_licences || [];
      const costs = projectDetails?.costs || [];
      console.log("costs --- ", costs);

      const costgroups = projectDetails?.costgroups || [];
      const costgroupsTV = createTV(
        costgroups,
        "cost_group_name",
        "cost_group_id"
      );
      const marketing_types = projectDetails?.marketing_types || [];
      const marketing_typesTV = createTV(
        marketing_types,
        "marketing_type_name",
        "marketing_type_id"
      );

      return {
        ...projectDetails,
        project,
        project_details,
        project_releases,
        project_products,
        project_tracks,
        project_licences,
        costs,
        costgroups,
        costgroupsTV,
        marketing_types,
        marketing_typesTV
      };
    }
  },
  methods: {
    ...mapActionObject(storeNS, projectsCatalogActions),

    onDialogCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },

    // Start Release
    onAddReleaseClick: function() {
      openModalRoute(this, "add_release", {
        mode: "add"
      });
    },
    onReleaseAdded: function(payload) {
      console.log("Created Release ", payload);
      // this[ActionTypes.LabelAccountsSetup.SET.ALL]({
      //   ...payload,
      //   selectedLabelDetails: this.selectedLabelDetails
      // });
      this.onDialogCancelled();
    },
    // End Release

    // Start Notes
    onNotesChange: function(payload) {
      console.log("notes ", payload);
      this[ActionTypes.ProjectDetails.UPDATE.SINGLE]({
        ...payload,
        selectedProjectDetails: this.selectedProjectDetails
      });
    },

    onNotesBlur: function(event) {
      this.onNotesChange({
        name: "notes",
        value: event.target.value
      });
    },
    // End Notes

    // Start Related Products
    onSelectedProduct: function(selectedProductId) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: selectedProductId,
          tab: "overview"
        }
      });
    },
    // End Related Products

    // Start Related Tracks
    onSelectedTrack: function(selectedTrackId) {
      this.$router.push({
        name: tracksListLDTRoutes.names.tab,
        params: {
          track_id: selectedTrackId,
          tab: "overview"
        }
      });
    },
    // End Related Tracks

    // Start Licencing
    onSelectedLincencing: function(selectedLincencingId) {
      this.$router.push({
        name: licensingListLDTRoutes.names.tab,
        params: {
          licensing_id: selectedLincencingId,
          tab: "overview"
        }
      });
    },
    // End Licencing

    // Start Related Contacts
    onRelatedContactDelete: function(contact) {
      console.log("contact ", contact);
      this[ActionTypes.ProjectRelatedContacts.DELETE.SINGLE]({
        contact,
        selectedProjectDetails: this.selectedProjectDetails
      });
    },
    onRelatedContactChange: function({ name, value, item }) {
      this[ActionTypes.ProjectRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedProjectDetails: this.selectedProjectDetails
      });
    },
    onUpdateProjectsCosts: function({ name, value, item }) {
      // console.log("onUpdateProjectsCosts ", { name, value, item });
      this[ActionTypes.ProjectCosts.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedProjectDetails: this.selectedProjectDetails
      });
    },

    onUploadFileClick: function() {
      openModalRoute(this, "dfile_uploader");
    },

    onUploadFile: function(payload) {
      console.log(":::", payload);
      // const formData = new FormData();
      // formData.append("action", "porcess_xls_order_import_file");
      // formData.append("section", "orders");
      // formData.append("file_name", payload.file);

      // formData.append("returnType", "json");
      // formData.append("output", "json");
      // formData.append("file_id", payload.file_id);
      // MHTTPCL.postFormData(LABEL_URL, formData);

      // this[ActionTypes.ProjectCostsLine.FETCH.ALL]({ ...payload });
      // this[ActionTypes.DistributionPackageLine.FETCH.ALL]({...payload})
    },
    onRelatedContactSelected: function(contact) {
      console.log(contact);
      this.$router.push({
        name: projectsListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview"
        }
      });
    }
    // End Related Contacts
  }
};
</script>

<style lang="scss">
.cmp-catalog-projects-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
}
</style>
